<template>
  <div class="charging-point-search">
    <!-- Nouvel onboarding : les commandes d'équipement de l'organisation (la liste ci-dessous est inchangée) -->
    <organization-commissionings v-if="organization && canSeeCommissionings" :organization-id="organization.id" kind="charging-point" />
    <charging-point-list
        :organization-id="organization.id" />
  </div>
</template>

<script>
import ChargingPointList from "@/components/elements/ChargingPointList.vue";
import OrganizationCommissionings from "@pages/Onboarding/Commissioning/OrganizationCommissionings.vue";

export default {
  components: {
    OrganizationCommissionings,
    ChargingPointList
  },

  data() {
    return {
      type: 0,
    }
  },

  mounted() {
    this.type = this.$route.query.type ?? null
  },

  computed: {
    canSeeCommissionings() {
      const permissions = this.currentUser?.permissions || []
      return permissions.includes('COMMISSIONING_REQUEST') || permissions.includes('ONBOARDING_MODULE_MANAGE')
    },
    organization() {
      return this.$parent.organization ?? null
    }
  },
}
</script>
